/* Livora London: FAQ accordion. Toggles aria-expanded on the clicked question and an
   `is-open` class on its answer panel; the actual open/close animation is pure CSS
   (grid-template-rows 0fr -> 1fr transition in the section's own stylesheet). Any number
   of questions may be open at once. */
(function () {
  if (window.lvFaqLoaded) return;
  window.lvFaqLoaded = true;

  function initOne(root) {
    if (root.dataset.lvFaqInit) return;
    root.dataset.lvFaqInit = 'true';

    root.querySelectorAll('.lv-faq__question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!isOpen));
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.classList.toggle('is-open', !isOpen);
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-lv-faq]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
